/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Отображение вкладок вида скидки на странице Скидка за объем.
   */
  app.TabsVolumeDiscountView = app.TabsBaseItemView.extend({

    unActiveTabInnerClass: 'link link_pseudo link_dark',
    unActiveContent: 'not_display',

    run: function () {},

    selectTab: function ($tab) {
      var that = this;
      // скрываем весь контент и делаем все табы не активными
      this.$el.find('.' + this.tabClass).each(function () {
        var $tab = $(this);
        that.hideTab($tab);
      });

      // устанавдиваем активный таб и показываем его контет
      var jsCatalogType = this.getTabContent($tab);
      this.showTab($tab);
      this.showContent(jsCatalogType);
    },

    getTabContent: function ($tab) {
      return $tab.data('js-catalog-view');
    },

    showTab: function ($tab) {
      $tab.addClass(this.activeTabClass);
      $tab.children('span').removeClass(this.unActiveTabInnerClass);
    },

    hideTab: function ($tab) {
      $tab.removeClass(this.activeTabClass);
      $tab.children('span').addClass(this.unActiveTabInnerClass);
    },

    showContent: function (jsCatalogType) {
      app.jsCatalogType = jsCatalogType;
      this.model.setQueryParams();
      Backbone.trigger('refresh-collection', {items: true, filters: true});
    },

    hideContent: function () {
    }
  });
})();

}.call(window));